// 青山预览页
import React, { useEffect, useState } from 'react';
import { useSimpleContext } from '@pages/applyView/_context';
import one from '@assets/images/previewStep/1-big.svg';
import two from '@assets/images/previewStep/2-big.svg';
import three from '@assets/images/previewStep/3-big.svg';
import { useUserData } from '@components/UserData';
import { getProjectInfo } from '@assets/apis/scientist';
import Basic from './basic';
import Project from './project';
import ApplyInfo from './apply';
import '../index.scss';

const img_step = [one, two, three];

const Scientist = (props) => {
  const { startOb, projectNo } = props;
  const [detail, setDetail] = useState(null);
  const { sciProjectConfigId } = useUserData();
  const { update } = useSimpleContext();
  useEffect(() => {
    if (sciProjectConfigId || projectNo) {
      const params = projectNo ? { projectNo } : { projectConfigId: sciProjectConfigId };
      getProjectInfo(params)
        .then((res) => {
          setDetail(res);
          update((t) => {
            t.recommendUploadStatus = res.recommendUploadStatus;
            t.projectNo = res.projectNo;
          });
        });
    }
  }, [sciProjectConfigId, projectNo]);

  useEffect(() => {
    startOb();
  }, [detail]);

  return detail ? (
    <div style={{ display: 'flex', flexDirection: 'column' }} className="preview-content" id="pdf-container">
      <div className="h2-title-wrap">
        <img src={img_step[0]} alt="" />
        <h2 id="base" className="catalogue-tag">基础信息</h2>
      </div>
      <Basic detail={detail.personInfo} isView={!!projectNo} />
      <div className="h2-title-wrap">
        <img src={img_step[1]} alt="" />
        <h2 id="project" className="catalogue-tag">科研信息</h2>
      </div>
      <Project detail={detail.studyInfo} isView={!!projectNo} />
      <div className="h2-title-wrap">
        <img src={img_step[2]} alt="" />
        <h2 id="apply" className="catalogue-tag">申报信息</h2>
      </div>
      <ApplyInfo detail={detail.applyInfo} isView={!!projectNo} />
    </div>
  ) : null;
};

export default Scientist;
